/// <reference path="../wpt.ts" />
var WPTNamespace;
(function (WPTNamespace) {
    var Widgets;
    (function (Widgets) {
        const LOG_CATEGORY = "WPT.Components.WvFilterResultTable";
        Widgets.WV_APPLICATION_NAME_ATTRIBUTE = 'data-app-name';
        Widgets.WV_CLASS_NAME_ATTRIBUTE = 'data-class-name';
        Widgets.WV_OBJECT_ID_ATTRIBUTE = 'data-object-id';
        const WV_FILTERRESULT_CLASS = "widget-component--workview-filter-result-table";
        const BOOL_CLASS = "wpt-boolean";
        const BOOL_TRUE_CLASS = "wpt-boolean--true";
        const BOOL_FALSE_CLASS = "wpt-boolean--false";
        class ComponentWvFilterResultTable extends Widgets.ComponentDataTable {
            constructor(core, container, parent, maxHeight = null) {
                super(core, container, parent, maxHeight);
                this._autoSelectThisRun = false;
                this._autoSelectMode = Widgets.DocumentAutoSelectMode.NONE;
                this._autoSelectOnHomeView = false;
                this._currentLayout = null;
                this._reselectOnRefresh = true;
                this._lastSelectedObject = null;
                this._autoSelectRowCreated = null;
                this._previousObjectRowCreated = null;
                this._objectDeselected = null;
                this.displayFilterResult = (data, classConfig, selectionConfig, rowCallback = null, isDynamicFilter = false) => {
                    this._log.info("WvFilterResultTableComponent.displayFilterResult()");
                    if (selectionConfig != null) {
                        this._autoSelectMode = selectionConfig.AutoSelectMode;
                        this._autoSelectOnHomeView = selectionConfig.AutoSelectOnHomeView;
                        this._autoSelectRowCreated = selectionConfig.AutoSelectRowCreated;
                        this._currentLayout = selectionConfig.CurrentLayout;
                        this._lastSelectedObject = selectionConfig.LastSelectedObject;
                        this._objectDeselected = selectionConfig.ObjectDeselected;
                        this._previousObjectRowCreated = selectionConfig.PreviousObjectRowCreated;
                        this._reselectOnRefresh = selectionConfig.ReselectOnRefresh;
                    }
                    if (!this._componentDiv.classList.contains(WV_FILTERRESULT_CLASS)) {
                        this._componentDiv.classList.add(WV_FILTERRESULT_CLASS);
                    }
                    let columns = [];
                    if (data.Heading.length > 0) {
                        let headingLength = data.Heading.length;
                        for (let i = 0; i < headingLength; i++) {
                            let heading = data.Heading[i];
                            let setting = {
                                Title: this._core.Locale.getTranslation(heading)
                            };
                            columns.push(setting);
                        }
                    }
                    else {
                        console.warn("WvFilterResultTableComponent.displayFilterResult: NO HEADING");
                    }
                    let settings = {};
                    if (data.Sorting && data.Sorting.length > 0) {
                        settings.Order = [];
                        data.Sorting.forEach(sort => {
                            settings.Order[settings.Order.length] = [sort.ColIndex, sort.Descending ? "desc" : "asc"];
                        });
                    }
                    this._autoSelectThisRun = false;
                    let previousObjStillAvailable = false;
                    let rows = [];
                    if (data.Result.length > 0) {
                        // Do we need to check for autoselect?
                        let firstObject = true;
                        if ((this._autoSelectMode == Widgets.DocumentAutoSelectMode.FIRST) || ((this._autoSelectMode == Widgets.DocumentAutoSelectMode.SINGLE) && (data.Result.length == 1))) {
                            if ((this._currentLayout != WPTNamespace.Navigation.HOME_VIEW_NAME) || this._autoSelectOnHomeView) {
                                this._autoSelectThisRun = true;
                            }
                        }
                        let resultLength = data.Result.length;
                        let hideClassObjectId = true;
                        for (let r = 0; r < resultLength; r++) {
                            let resultValue = data.Result[r];
                            // Need some special callback handing to manage previous document selection and/or autoselect support
                            let callBack = (this._autoSelectThisRun && firstObject) ? this._autoSelectRowCreated : null;
                            if (this._lastSelectedObject != null && resultValue.Class.Application.Name == this._lastSelectedObject.Application &&
                                resultValue.Class.Name == this._lastSelectedObject.Class && resultValue.Id == this._lastSelectedObject.ObjectId) {
                                previousObjStillAvailable = true;
                                if (this._reselectOnRefresh)
                                    callBack = this._previousObjectRowCreated;
                            }
                            let rowValues = [];
                            let metaValues = [];
                            let rowData = {
                                Values: rowValues,
                                Metadata: metaValues
                            };
                            rows.push(rowData);
                            firstObject = false;
                            let appMeta = {
                                Name: Widgets.WV_APPLICATION_NAME_ATTRIBUTE,
                                Value: resultValue.Class.Application.Name
                            };
                            metaValues.push(appMeta);
                            let classMeta = {
                                Name: Widgets.WV_CLASS_NAME_ATTRIBUTE,
                                Value: resultValue.Class.Name
                            };
                            metaValues.push(classMeta);
                            let objectMeta = {
                                Name: Widgets.WV_OBJECT_ID_ATTRIBUTE,
                                Value: resultValue.Id.toString(10)
                            };
                            metaValues.push(objectMeta);
                            let valuesLength = resultValue.Values.length;
                            for (let v = 0; v < valuesLength; v++) {
                                let value = resultValue.Values[v];
                                // set filter type for columns with datasets to 'select'
                                if (classConfig && classConfig.Attributes) {
                                    let attrConfig = classConfig.Attributes.find(attr => attr.Name === value.Name);
                                    if (attrConfig && attrConfig.Dataset && attrConfig.Dataset.length > 0) {
                                        columns[v].FilterType = "Select";
                                    }
                                }
                                if (isDynamicFilter && hideClassObjectId && (value.Name == 'objectname' || value.Name == 'rmobjectname') && value.Value == "") {
                                    hideClassObjectId = false;
                                }
                                let attrValue = value.Value;
                                let cellValue = {
                                    Value: attrValue,
                                    Display: attrValue,
                                    Sort: attrValue,
                                    Filter: attrValue,
                                    PreventSanitising: false
                                };
                                rowValues.push(cellValue);
                                switch (value.DataType) {
                                    case 'Date':
                                        let dateValueString = "";
                                        if (attrValue != "") {
                                            let dateValue = this._core.Functions.getTimezoneCorrectedDateTime(attrValue + "T00:00:00");
                                            dateValueString = this._core.Locale.DateFormatter.format(dateValue);
                                            cellValue.Value = dateValue.getTime();
                                            cellValue.Sort = dateValue.getTime();
                                            cellValue.Display = dateValueString;
                                            cellValue.Filter = attrValue + " " + dateValueString;
                                        }
                                        break;
                                    case 'DateTime':
                                        let dateTimeValueString = "";
                                        if (attrValue != "") {
                                            let dateTimeValue = this._core.Functions.getTimezoneCorrectedDateTime(attrValue);
                                            dateTimeValueString = this._core.Locale.DatetimeFormatter.format(dateTimeValue);
                                            cellValue.Value = dateTimeValue.getTime();
                                            cellValue.Sort = dateTimeValue.getTime();
                                            cellValue.Display = dateTimeValueString;
                                            cellValue.Filter = attrValue + " " + dateTimeValueString;
                                        }
                                        break;
                                    case 'Boolean':
                                        // set filter type for boolean columns to 'select'
                                        if (r === 0) {
                                            columns[v].FilterType = "Select";
                                        }
                                        if (attrValue !== "") {
                                            let boolSpan = document.createElement('span');
                                            boolSpan.classList.add(BOOL_CLASS, 'wpt-font');
                                            if (attrValue == 'TRUE') {
                                                boolSpan.classList.add('wpt-font-icon_OK', BOOL_TRUE_CLASS);
                                            }
                                            else {
                                                boolSpan.classList.add('wpt-font-icon_CloseCircle', BOOL_FALSE_CLASS);
                                            }
                                            cellValue.Display = boolSpan.outerHTML;
                                            cellValue.PreventSanitising = true;
                                        }
                                        else {
                                            let boolSpan = document.createElement('span');
                                            boolSpan.classList.add(BOOL_CLASS, 'wpt-font', 'wpt-font-icon_QuestionCircle');
                                            cellValue.Value = "EMPTY";
                                            cellValue.Sort = "EMPTY";
                                            cellValue.Display = boolSpan.outerHTML;
                                            cellValue.Filter = "EMPTY";
                                            cellValue.PreventSanitising = true;
                                        }
                                        break;
                                    case 'Integer':
                                    case 'Float':
                                    case 'Decimal':
                                        let numberValueString = "";
                                        if (attrValue != "") {
                                            let numberValue = new Number(attrValue);
                                            numberValueString = this._core.Locale.NumberFormatter.format(numberValue.valueOf());
                                            cellValue.Value = numberValue;
                                            cellValue.Sort = numberValue;
                                            cellValue.Display = numberValueString;
                                            let numberValueNoGrouping = this._core.Locale.NumberNoGroupingFormatter.format(numberValue.valueOf());
                                            cellValue.Filter = numberValue + " " + numberValueString + " " + numberValueNoGrouping;
                                        }
                                        break;
                                    case 'Currency':
                                        let currencyValueString = "";
                                        if (attrValue != "") {
                                            let numberValue = new Number(attrValue);
                                            currencyValueString = this._core.Locale.CurrencyFormatter.format(numberValue.valueOf());
                                            cellValue.Value = numberValue;
                                            cellValue.Sort = numberValue;
                                            cellValue.Display = currencyValueString;
                                            let currencyValueNoGrouping = this._core.Locale.CurrencyNoGroupingFormatter.format(numberValue.valueOf());
                                            cellValue.Filter = numberValue + " " + currencyValueString + " " + currencyValueNoGrouping;
                                        }
                                        break;
                                    case 'Alphanumeric':
                                    default:
                                        break;
                                }
                            }
                            rowData.ClickCallback = rowCallback;
                            rowData.CreatedCallback = callBack;
                        }
                        if (isDynamicFilter && hideClassObjectId) {
                            let rowsLength = rows.length;
                            for (let r = 0; r < rowsLength; r++) {
                                let row = rows[r];
                                row.Values = row.Values.slice(0, row.Values.length - 1);
                            }
                            columns = columns.slice(0, columns.length - 1);
                        }
                    }
                    else {
                        console.warn("WvFilterResultTableComponent.displayFilterResult: NO DATA");
                    }
                    let tableData = {
                        Columns: columns,
                        Rows: rows,
                        Settings: settings
                    };
                    if (previousObjStillAvailable)
                        this._autoSelectThisRun = false;
                    else if (this._lastSelectedObject != null)
                        this._objectDeselected();
                    window.setTimeout(this.displayData.bind(this, tableData), 0);
                    return this._autoSelectThisRun;
                };
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("WvFilterResultTableComponent::constructor");
            }
        }
        Widgets.ComponentWvFilterResultTable = ComponentWvFilterResultTable;
    })(Widgets = WPTNamespace.Widgets || (WPTNamespace.Widgets = {}));
})(WPTNamespace || (WPTNamespace = {}));
